import React from 'react';
import { ChevronRight, MapPin } from 'lucide-react';

function NextDeliveryFooter({ delivery, onClick }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-brand-primary shadow-2xl z-50">
      <button
        onClick={onClick}
        className="w-full px-5 py-4 hover:bg-brand-primary/5 active:bg-brand-primary/10 transition-colors"
      >
        <div className="flex items-center justify-between">
          {/* Left Section */}
          <div className="flex items-center gap-3">
            {/* Sequence Badge */}
            <div className="w-12 h-12 rounded-full bg-brand-primary text-white flex items-center justify-center font-bold text-lg shadow-md">
              {delivery.sequence}
            </div>

            {/* Delivery Info */}
            <div className="text-left">
              <div className="text-xs text-brand-primary font-semibold uppercase tracking-wide mb-0.5">
                Siguiente Entrega
              </div>
              <div className="font-bold text-gray-900 text-base mb-0.5">
                {delivery.recipient_name}
              </div>
              <div className="flex items-center gap-1.5 text-xs text-gray-500">
                <MapPin className="w-3.5 h-3.5" />
                <span className="truncate max-w-[200px]">
                  {delivery.user_name}
                </span>
              </div>
            </div>
          </div>

          {/* Right Arrow */}
          <ChevronRight className="w-6 h-6 text-brand-primary flex-shrink-0" />
        </div>
      </button>
    </div>
  );
}

export default NextDeliveryFooter;